import { BaseComponent, BElement } from "utils/base-component"
import "./index.scss"

require.context("./static", false, /\.(svg|webp)$/)

export class ModalAppPopup extends BaseComponent {
  static cssClass = "modal-app-popup"

  private close!: BElement
  private open!: BElement
  private closedClass!: string

  init() {
    const closeElement = this.element("close-button")
    if (!closeElement) {
      throw new Error("Close button not found")
    }
    const openElement = this.element("open-button")
    if (!openElement) {
      throw new Error("Open button not found")
    }

    this.close = closeElement
    this.open = openElement

    this.closedClass = `${ModalAppPopup.cssClass}--closed`

    if (document.cookie.indexOf("appPopupClosed=1") !== -1) {
      this.root.classList.add(this.closedClass)
      document.documentElement.style.paddingTop = "0"
    }

    this.close.element.addEventListener("click", (e) => {
      e.preventDefault()

      const expiryDate = new Date()
      expiryDate.setMonth(expiryDate.getMonth() + 1)

      document.cookie = `appPopupClosed=1; expires=${expiryDate.toUTCString()}; path=/`

      this.root.classList.add(this.closedClass)
    })

    this.open.element.addEventListener("click", () => {
      const expiryDate = new Date()
      expiryDate.setMonth(expiryDate.getMonth() + 1)

      document.cookie = `appPopupClosed=1; expires=${expiryDate.toUTCString()}; path=/`

      this.root.classList.add(this.closedClass)
    })
  }
}
